const checkErrorsGroupSelector = (group) => {
    if (group && group.id && typeof group.id === 'string') {
        return {};
    } else {
        return { groupSelector: 'Debe seleccionar un grupo válido' };
    }
};

export default checkErrorsGroupSelector